import React from 'react';
import './ExcludedTeacherMessage.css';

const ExcludedTeacherMessage = ({ teacherName }) => {
  return (
    <div className={`message-item`}>
      <div className="message-content">
        <p className="message-text">This chat has been closed as <span className="teacher-name">{teacherName}</span> is no longer with openhouse.</p>
      </div>
    </div>
  );
};

export default ExcludedTeacherMessage;